module.exports = __webpack_public_path__ + "static/img/glucose-monitor.c22bdb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/glucose-monitor.png
// module id = sXfk
// module chunks = 1